// Export a single pure function that will be used by pdf/excel exporters to map grid values to excel/pdf cells.

// eslint-disable-next-line no-unused-vars
export function formatCellValue({ gridCell, value, column }) {
    // gridCell: { rowType, column, value, groupSummaryItems }
    // column: column metadata
    if (!gridCell) return value;


    if (gridCell.rowType === 'data') {
        if (gridCell.column && gridCell.column.cellTemplate === 'ActiveStatus') {
            if (gridCell.value === 'N' || !gridCell.value) return 'Active';
            if (gridCell.value === 'Y' || gridCell.value) return 'Inactive';
        }


        if (gridCell.column && gridCell.column.dataType === 'datetime' && gridCell.value) {
            try {
                const d = new Date(gridCell.value);
                return `${d.toLocaleDateString()}, ${d.toLocaleTimeString()}`;
            } catch (err) {
                return gridCell.value;
            }
        }


        if (gridCell.column && gridCell.column.cellTemplate === 'RadioTemplate') {
            if (gridCell.value === 'N' || !gridCell.value) return 'No';
            if (gridCell.value === 'Y' || gridCell.value) return 'Yes';
        }


        if (gridCell.column && gridCell.column.dataType === 'date' && gridCell.column.format === 'dd MMM yyyy' && gridCell.value) {
            const d = new Date(gridCell.value);
            return d.toLocaleDateString();
        }
    }


    // Defaults
    return value;
}